<ng-template [ngIf]="posts !== null && moduleData !== null">
  <section class="my-12 bg-white">
    <div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="lg:text-center">
        <p
          class="text-base leading-6 text-indigo-600 font-semibold tracking-wide uppercase"
        >
          {{ moduleData.preHeader }}
        </p>
        <h3
          class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10"
        >
          {{ moduleData.title }}
        </h3>
        <p class="mt-4 max-w-2xl text-xl leading-7 text-gray-500 lg:mx-auto">
          {{ moduleData.subtitle }}
        </p>
      </div>

      <div class="mt-10">
        <ul class="md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
          <li *ngFor="let post of posts">
            <a class="flex" href="/blog/{{ post.fields.slug }}">
              <div class="flex-shrink-0">
                <div
                  class="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white"
                >
                  <img
                    class="h-12 w-12 rounded-md"
                    src="{{ post.fields.image.url }}?w=50&h=50"
                    alt="{{ post.fields.image.label }}"
                    loading="lazy"
                  />
                </div>
              </div>
              <div class="ml-4">
                <h4 class="text-lg leading-6 font-medium text-gray-900">
                  {{ post.fields.title }}
                </h4>
                <p class="mt-2 text-base leading-6 text-gray-500">
					{{ post.excerpt }}
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</ng-template>
